<template>
  <div>
    <ConfirmationBoxes :detail="client">
      <template #box2="{ item }">
        <v-row no-gutters>
          <v-col cols="4"> {{ $t('user.user_customer-name') }} </v-col>
          <v-col>{{ item.customerName }}</v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="4"> {{ $t('sale.sale_customer-company-name') }} </v-col>
          <v-col> {{ item.organizationName }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="4"> {{ $t('sale.sale_customer-store-name') }} </v-col>
          <v-col>{{ item.shopName }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="4"> {{ $t('common.input_currency') }} </v-col>
          <v-col>{{ item.currency.label }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="4">注文日 </v-col>
          <v-col>{{ item.saleDate }} </v-col>
        </v-row>
      </template>
    </ConfirmationBoxes>
  </div>
</template>
<script>
import { ConfirmationBoxes } from '@/components/items'
import ClientInfoJs from './CustomerInfo'

export default {
  components: {
    ConfirmationBoxes
  },
  props: {
    pageType: { default: 'history' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    }
  },
  created() {
    this.init()
  },
  data: () => ({
    client: []
  }),
  methods: {
    init() {
      if (this.pageType === 'history') {
        this.client = ClientInfoJs.setHistoryInfo(this.recItems)
        return
      }
      if (this.pageType === 'register') {
        this.client = ClientInfoJs.setRegisterInfo(this.recItems)
        return
      }
    }
  },
  watch: {
    recItems: {
      deep: true,
      handler(newVal, oldVal) {
        this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.headingStyle {
  font-size: 15px;
  font-weight: bold;
}
</style>
